import i18next from "i18next";
import { CommonButton, FormElementWrapper, FormWrapper, Upload } from "../../../../components";
import { useRef } from "react";
import * as yup from "yup";

const validation = () => {
    return yup.object().shape({
        receipt: yup
            .string()
            .nullable()
            .required(i18next.t('validation.common.image'))
    });
};

export default function UploadReceipt({ receiptData, onSubmit }) {
    const uploadRef1 = useRef();
    return (
        <>
            {' '}
            <FormWrapper
                row={true}
                initialValues={{ ...receiptData }}
                onSubmit={onSubmit}
                enableReinitialize={true}
                data={receiptData}
                validation={validation}
            >
                {(props) => {
                    return (
                        <>
                            <FormElementWrapper
                                md={12}
                                lg={12}
                                mandatory={true}
                                label={i18next.t('text.report.uploadReceiptLabel')}
                                element={() => (
                                    <Upload
                                        name="receipt"
                                        mediaFor="paymentReceipt"
                                        isAspectSlider={true}
                                        formik={props}
                                        type="image"
                                        imageUrlList={
                                            receiptData?.receiptUrl === ''
                                                ? ''
                                                : props?.values?.viewImageUrl
                                        }
                                        isCrop={false}
                                        ref={uploadRef1}
                                    />
                                )}
                            />
                            <div className="mt-4 text-end">
                                <CommonButton type="submit" className="btn btn-primary">
                                    {i18next.t('text.common.submit')}
                                </CommonButton>
                            </div>
                        </>
                    );
                }}
            </FormWrapper>
        </>
    )
};